module.exports = __webpack_public_path__ + "6ae8f019f35d661d9f1dbacf15a7a8af.MP3";